import { TaskInvoicingFrequencies, Week } from './../task.constants';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TaskStatuses } from '../task.constants';
import * as _ from 'lodash';
import { ITask, ITaskProduct } from '../task.interface';
import { TaskHttpService } from '../task-http.service';
import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, forkJoin, lastValueFrom, map, Observable, of, startWith, Subject, Subscription, switchMap } from 'rxjs';
import { TaskCommentComponent } from '../task-comment/task-comment.component';
import { TaskCommentService } from '../task-comment/task-comment.service';
import { ITaskComment } from '../task-comment/task-comment.interface';
import { TaskWorkerWhappSelComponent } from '../task-worker-whapp-sel/task-worker-whapp-sel.component';
import { TaskMovementsComponent } from '../task-movements/task-movements.component';
import { TaskShareComponent } from '../task-share/task-share.component';
import { MatSelect } from '@angular/material/select';
import { Frequency, Options, RRule } from 'rrule';
import { TaskClientAddressSelComponent } from '../task-client-address-sel/task-client-address-sel.component';
import { Router } from '@angular/router';
import { MatchClientModalComponent } from '../match-client-modal/match-client-modal.component';
import { ITaskRequest } from '../../../task-requests-page/task-requests/task-requests.interface';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { IAppointment } from '../appoinment/appointment.interface';
import { IDetailItem, getEmptyDetailItem } from '../../../../shared/components/detail-item/detail-item.interface';
import { IBillingDocument, IBillingDocumentTypes } from '../../../billing-documents-page/billing-documents/billing-documents.interface';
import { InvoiceStatuses } from '../../../billing-documents-page/billing-documents/billing-documents.constants';
import { IExpense, getEmptyDetailItemExpense } from '../../../expenses-page/expenses/expenses.interface';
import { TaskRequestsService } from '../../../task-requests-page/task-requests/task-requests.service';
import { UserService } from '../../../users-page/users/users.service';
import { ServiceAgreementHttpService } from '../../../service-agreements-page/service-agreements/service-agreements.service';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { ProductsService } from '../../../products-page/products/products.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { AppointmentsService } from '../appoinment/appointment.service';
import { BillingDocumentService } from '../../../billing-documents-page/billing-documents/billing-documents.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { DeliveryNotesService } from '../../../delivery-notes-page/delivery-notes/delivery-notes.service';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { DeliveryNotesPDFModalComponent } from '../../../delivery-notes-page/delivery-notes/delivery-notes-pdf-modal/delivery-notes-pdf-modal.component';
import { BillingDocumentsModalComponent } from '../../../billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { BillingDocumentsPDFModalComponent } from '../../../billing-documents-page/billing-documents/billing-documents-pdf-modal/billing-documents-pdf-modal.component';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { ILocation } from '../../../../shared/components/location-modal/location-modal.interfaces';
import { IProduct } from '../../../products-page/products/products.interface';
import { LocationPickerModalComponent } from '../../../../shared/components/location-picker-modal/location-picker-modal.component';
import { toNativeDate } from '../../../../shared/components/recurrence/recurrence.component';
import { IServiceAgreement } from '../../../service-agreements-page/service-agreements/service-agreements.interface';
import { ICustomDialogOptions } from '../../../../shared/services/dialog/custom-dialog/custom-dialog-options.interface';
import { CategoriesModalComponent } from '../../../categories-page/categories/categories-modal/categories-modal.component';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';
import { watsappURL } from '../../../../../env-config';
import { IFile } from '../../../../shared/components/files/file.interface';
import { FileViewModalComponent } from '../../../../shared/components/file-view-modal/file-view-modal.component';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';
import { ExternalRequestModalComponent } from '../../../../shared/components/external-request/external-request-modal/external-request-modal.component';

let self: any;

let moreThan24Hours = false;
let recurringTask = false;
@Component({
  selector: 'app-task-modal',
  templateUrl: './task-modal.component.html',
  styleUrls: ['./task-modal.component.css']
})
export class TaskModalComponent implements OnInit {
  private statusInput!: MatSelect;
  @ViewChild('statusInput', { static: false }) set input(input: MatSelect) {
    if (input) this.statusInput = input;
  };
  @ViewChild('bottom', { static: false }) bottomElement!: ElementRef;
  @ViewChild('top', { static: false }) topElement!: ElementRef;

  action: string = '';
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showStart: boolean = true;
  showEnd: boolean = true;
  showEdit: boolean = true;
  loading: boolean = false;
  task!: ITask;
  newStatus!: string;
  comments: ITaskComment[] | any = [];
  form!: UntypedFormGroup;
  formValueChanged: boolean = false;
  saving: boolean = false;
  submitted = false;
  lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  taskInvoicingFrequencies = TaskInvoicingFrequencies;
  taskInvoicingFrequenciesKeys = Object.keys(TaskInvoicingFrequencies);
  taskStatuses: any = TaskStatuses;
  taskStatusesKeys = Object.keys(TaskStatuses);
  taskStatusColors: any = {};
  taskRequest!: ITaskRequest
  status!: string;
  // statusEditable: boolean = true;
  categories: ICategory[] = [];
  $clients: Observable<any> = of();
  workers: IWorker[] = [];
  $products: Observable<any> = of();
  // productItems: ITaskProduct[] = [];
  isDev!: boolean;
  curr!: string;
  subscriptions: Subscription;
  appoinment!: IAppointment;
  subtotal: number = 0;
  tax: number = 0;
  taxPercentage: number = 0;
  total: number = 0;
  notEditableAlert: boolean = false;
  scheduling: boolean = false;
  recurringTask: boolean = false;
  frequency = Frequency;
  week = Week;

  recurrence: any;
  project: any;

  scrollToComments = false;
  emptyItem = getEmptyDetailItem();

  // recurringWDays = [false, false, false, false, false, false, false];
  private weekdayMap = [
    RRule.SU,
    RRule.MO,
    RRule.TU,
    RRule.WE,
    RRule.TH,
    RRule.FR,
    RRule.SA,
  ];

  rruleSchedule!: string;
  haveRecurrence: { recurrenceRule?: string } = {};
  nextAppointments!: [];
  recuFreq!: string;
  recuCount!: string;
  recuDay!: string;
  recuWeek!: string[];
  startDate!: string;
  startDateTime!: string;
  untilDate!: string;
  recuInterval!: string;
  currentUntilDate: any;
  showUpdateUntilDate!: boolean;

  invoice!: IBillingDocument;
  invoiceStatuses: any = InvoiceStatuses;
  agreementInvoicing!: boolean;

  constructedForm: boolean = false;
  refreshPage: boolean = false;

  emptyItemExpense = getEmptyDetailItemExpense();

  constructor(
    public _TaskHttpService: TaskHttpService,
    public _TaskCommentService: TaskCommentService,
    private _TaskRequestsService: TaskRequestsService,
    public _UserService: UserService,
    public _ServiceAgreementHttpService: ServiceAgreementHttpService,
    public _CategoriesService: CategoriesService,
    public _ClientsService: ClientsService,
    public _ProductsService: ProductsService,
    public _WorkersService: WorkersService,
    public dialogRef: MatDialogRef<any>,
    public commentDialogRef: MatDialogRef<any>,
    public movementsDialogRef: MatDialogRef<any>,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService,
    private _UtilsService: UtilsService,
    public _AppointmentsService: AppointmentsService,
    // public _ScheduleService: SchedulesService,
    private _BillingDocumentService: BillingDocumentService,
    private _AlertService: AlertService,
    private _SettingsService: SettingsService,
    private _DeliveryNotesService: DeliveryNotesService,
    private _router: Router,
    private cdr: ChangeDetectorRef
  ) {
    self = this;
    this.dialog = dialogRef;
    this.subscriptions = new Subscription();
  }

  formLevel: number = 0;
  setFormLevel() {
    console.log(this.task.status)
    if (this.task.status == 'CANCELLED') this.formLevel = 200;
    else if (this.task.status == 'INVOICED') this.formLevel = 150;
    else if (this.task.status == 'COMPLETED') this.formLevel = 100;
    else if (this.task.status == 'ONGOING') this.formLevel = 75;
    else if (this.task.status == 'SCHEDULED') this.formLevel = 50;
    else if (this.task.status == 'QUOTED') this.formLevel = 25;
    else this.formLevel = 0;
  }

  statusChanged() {
    this.task.status = this.f['status'].value;
    // this.statusEditable = false;
    this.setFormLevel();
  }

  /*
  statusSetEditable() {
    if (this.readOnly) return;
    this.statusEditable = true;
    this.setFormLevel();
    setTimeout(() => {
      if (this.statusInput) this.statusInput.open();
    })
  }
  */

  setStatusCompleted() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Completar trabajo",
      message: "¿Desea cambiar este trabajo a estado Completado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
      if (confirmation) {
        this.setStatus('COMPLETED');
        this.onSubmit('COMPLETED');
      }
    });
  }

  setStatus(newStatus: string, setEditable: boolean = true) {
    this.f['status'].setValue(newStatus);
    this.statusChanged();
    if (setEditable) this.setEditable();
  }

  openMatchClientModal() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(MatchClientModalComponent, config);
    self.dialogRef.componentInstance.client = this.taskRequest.client;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) {
        this.task.client = result;
        this.f['client'].setValue(result);
        const address = _.get(result, 'addresses[0]', {});
        this.f['location'].setValue(_.get(address, 'address', ''));
        this.f['latitude'].setValue(_.get(address, 'coordinates[0]', 0));
        this.f['longitude'].setValue(_.get(address, 'coordinates[1]', 0));
      }
    });
  }

  openDeliveryNote() {
    if (this.task.deliverynote) {
      this.openDeliveryNotePDF(this.task.deliverynote);
    } else {
      const modalOptions: IConfirmationDialogOptions = {
        title: "Generar Albarán",
        message: "¿Desea generar el albarán para este trabajo?\nLuego podra compartirlo con el cliente para su firma de conformidad.",
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };
      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
        if (confirmation) {
          this.createDeliveryNote();
        }
      });
    }
  }

  createDeliveryNote() {
    const note = {
      company: this._AuthService.companyId(),
      client: this.task.client?._id,
      description: this.task.description,
      tasks: [this.task._id]
    };
    this._DeliveryNotesService.createDeliveryNote(note).subscribe(note => {
      this.setEditable(false);
      this.submitted = false;
      this.saving = false;
      this.scheduling = false;
      this.getTask();
    })
  }

  openDeliveryNotePDF(deliverynote: any) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dn_pdfDialogRef = this._dialog.open(DeliveryNotesPDFModalComponent, config);
    self.dn_pdfDialogRef.componentInstance.document = deliverynote;

    self.dn_pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.dn_pdfDialogRef = null;
    });
  }

  invoiceTask() {
    if (this.f['total'].value <= 0) {
      return this._AlertService.warn("El importe Total no puede ser cero");
    }

    if (this.form.invalid) {
      this.setEditable();
      this.submitted = true;
      this.form.markAllAsTouched();
      return this._AlertService.warn("Formulario incorrecto");
    };

    const modalOptions: IConfirmationDialogOptions = {
      title: "Facturar",
      message: "Esta seguro que desea Facturar este Trabajo?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
      if (confirmation) {
        let config = new MatDialogConfig();
        config.width = '1200px';
        config.maxWidth = '90vw';
        config.viewContainerRef = this._viewContainerRef;
        self.dialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
        self.dialogRef.componentInstance.tasks = [this.task];
        self.dialogRef.componentInstance.document = {
          type: IBillingDocumentTypes.INVOICE,
          client: this.task.client
        };
        self.dialogRef.componentInstance.readOnly = false;
        self.dialogRef.componentInstance.editting = true;
        self.dialogRef.componentInstance.redirectToBill = true;

        self.dialogRef.afterClosed().subscribe((result: any) => {
          this.setEditable(false);
          this.submitted = false;
          this.saving = false;
          this.scheduling = false;
          this.getTask();
        });
      }
    });
  }

  openInvoice() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = this.invoice;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  async ngOnInit() {
    //this.readOnly = this.task.client ? true : false;
    this.getStatusColors();
    this.setFormLevel();
    console.log("ngOnInit")

    // if (this.task.status) this.statusEditable = false;

    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');
    this._WorkersService.getWorkers({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'firstname lastname',
      skip: 0,
      limit: 1000
    }).subscribe((workers) => {
      this.workers = workers;
    });

    this.getCategories();
    const products: any = this.task?.products, expenses: any = this.task?.expenses;
    if (!Array.isArray(products) || products.length === 0) {
      this.task.products = [getEmptyDetailItem()];
    }
    if (!Array.isArray(expenses) || expenses.length === 0) {
      this.task.expenses = [getEmptyDetailItemExpense()];
    }
    // if (!(products.length > 0)) this.task.products = [getEmptyDetailItem()];
    // if (!(expenses.length > 0)) this.task.expenses = [getEmptyDetailItemExpense()];

    if (this.task._id) {
      this.action = 'Modificar';
      await this.getTask(this.newStatus);

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 2000);
      // REFACTOR

    }
    else {
      if (this.task.status == 'QUOTED' && this.scheduling) {
        this.action = 'Programar';
        this.task.status = 'SCHEDULED';
      }
      else if (this.task.client) {  //  revisar ????
        this.action = 'Duplicar';
        const rule = (this.task.appointment?.schedule as any)?.recurrenceRule;
        if (rule) {
          //this.setRecurringTask(true);
          // this.recurrence = { rule };
          // this.recurrence.recurringFrequency = this.frequency[getValue('FREQ', rule)];
          console.log(rule);
        }
        // this.task.products = [getEmptyDetailItem()];
      }
      else {
        this.action = 'Crear';
        if (this.taskRequest) this.openMatchClientModal()
        // this.task.taxPercentage = TaxPercentage;
      }
      await this.buildForm();
      if (this.recurrence) this.setRecurringTask(true);
      this.constructedForm = true;
    }

    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal()
    });
  }

  async getStatusColors() {
    this.taskStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#FF9E00' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.taskStatusColors.OPEN = color; this.taskStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_ONGOING_COLOR)
      .then((color) => { this.taskStatusColors.ONGOING = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_COMPLETED_COLOR)
      .then((color) => { this.taskStatusColors.COMPLETED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.taskStatusColors.CANCELLED = color });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getCategories() {
    this._CategoriesService.getCategories({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'name',
      skip: 0,
      limit: 1000
    }).subscribe((categories) => {
      this.categories = categories;
    });
  }

  async getTask(newStatus?: string) {
    this.productsChanged = false;
    console.log("getTask")
    console.log(newStatus)

    this._BillingDocumentService.getBillingDocumentByTask(this.task).subscribe(document => {
      if (document)
        if (!(document.status == this.invoiceStatuses.CANCELLED || document.isDeleted))
          this.invoice = document;
    });

    this.setRecurringTask(false);
    if (newStatus == 'SCHEDULED') this.scheduling = true;
    else this.scheduling = false;
    this.loading = true;
    this.comments = null;

    console.log(this.scheduling)

    this._TaskHttpService.getTask(this.task._id || '').subscribe(async (task) => {
      this.task = task;
      const products: any = this.task.products;
      const expenses: any = this.task.expenses;
      if (!(products.length > 0)) this.task.products = [getEmptyDetailItem()]
      if (!(expenses.length > 0)) this.task.expenses = [getEmptyDetailItemExpense()];

      /*  REFACTOR ************************************/
      /*
      this.productItems = [];
      for (let el of task.products) {
        const product = await this._ProductsService.getProduct(el.product).toPromise();
        el.product = product;
        this.productItems.push(el);
      }
      */
      /*  REFACTOR ************************************/

      this._AppointmentsService.getAppointment(this.task._id || '').subscribe(async (result) => {
        this.appoinment = result;
        //console.log(this.appoinment)
        this.haveRecurrence = (this.appoinment.schedule) as { recurrenceRule?: any };

        if (this.haveRecurrence) {
          this._AppointmentsService.getAppointments({
            filters: {
              schedule: (this.appoinment.schedule as any)?._id,
              startDate: (this.appoinment as any).startDate
            }, company: this._AuthService.companyId()
          }).subscribe((result) => {
            this.nextAppointments = result;

            this.nextAppointments.forEach((appo: any) => {
              appo.startDateTime = this.formatDateTimeFromISO(appo?.task?.scheduledStart);
            });

            console.log(this.nextAppointments)
          })

          const freqMatch = this.haveRecurrence.recurrenceRule ? this.haveRecurrence.recurrenceRule.match(/FREQ=([^;]*)/) : null;
          this.recuFreq = freqMatch ? this.formatFreq(freqMatch[1]) : '';

          const recuIntervalMatch = this.haveRecurrence.recurrenceRule?.match(/INTERVAL=(\d+)/);
          this.recuInterval = recuIntervalMatch ? recuIntervalMatch[1] : '';

          const recuCountMatch = this.haveRecurrence.recurrenceRule?.match(/COUNT=(\d+)/);
          this.recuCount = recuCountMatch ? recuCountMatch[1] : '';

          if (this.recuFreq === 'Mensual') {
            const recuDayMatch = this.haveRecurrence.recurrenceRule?.match(/BYMONTHDAY=([^;]*)/);
            this.recuDay = recuDayMatch ? recuDayMatch[1] : '';
          } else if (this.recuFreq === 'Semanal') {
            const recuWeekMatch = this.haveRecurrence.recurrenceRule?.match(/BYDAY=([^;]*)/);
            this.recuWeek = recuWeekMatch ? this.formatWeek(recuWeekMatch[1]) : [];
          }

          const untilMatch = this.haveRecurrence.recurrenceRule?.match(/UNTIL=(\d{8})T(\d{6})Z/);
          if (untilMatch) {
            const untilDateUTC = new Date(Date.UTC(
              parseInt(untilMatch[1].substring(0, 4)),
              parseInt(untilMatch[1].substring(4, 6)) - 1,
              parseInt(untilMatch[1].substring(6, 8)),
              parseInt(untilMatch[2].substring(0, 2)),
              parseInt(untilMatch[2].substring(2, 4)),
              parseInt(untilMatch[2].substring(4, 6))
            ));
            this.untilDate = untilMatch ? this.formatDateFromISO(untilDateUTC) : '';
          } else {
            this.untilDate = "Luego de " + this.recuCount + " visitas"
          }
          this.startDate = this.appoinment?.createdAt ? this.formatDateFromISO(this.appoinment?.createdAt) : '';
        }

        this.startDateTime = this.task.scheduledStart ? this.formatDateTimeFromISO(this.task.scheduledStart) : '';

        await this.buildForm();
        // this.buildeado = true;

        this.loading = false;
        if (newStatus) this.setStatus(newStatus);
        else this.setStatus(this.task.status || '', false);
      });
    });
  }

  scrollDialogToTop() {
    if (this.topElement && this.topElement.nativeElement) {
      this.topElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollDialogToComments() {
    if (this.bottomElement && this.bottomElement.nativeElement) {
      this.bottomElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  get detailItems(): IDetailItem[] {
    return (this.task?.products || []).map(product => ({
      ...product,
      detail: product.detail || ''
    }));
  }

  get safeExpenses(): IExpense[] {
    return this.task?.expenses ?? [];
  }

  formatFreq(freqString: string): string {
    let frequency: string;
    switch (freqString) {
      case 'DAILY':
        frequency = 'Diaria';
        break;
      case 'WEEKLY':
        frequency = 'Semanal';
        break;
      case 'MONTHLY':
        frequency = 'Mensual';
        break;
      default:
        frequency = 'Otro';
    }
    return frequency;
  }

  formatWeek(dayString: string): string[] {
    const daysArray = dayString.split(',').map(day => Week[day.trim()]);
    daysArray.sort((a, b) => {
      const weekOrder = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
      return weekOrder.indexOf(a) - weekOrder.indexOf(b);
    });

    return daysArray;
  }

  formatDate(dateString: string) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${day}/${month}/${year}`;
  }

  formatDateFromISO(dateString: any) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatDateTimeFromISO(dateString: any) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  getComments() {
    this._TaskCommentService.getComments({
      task: this.task._id,
      // filters: { task: this.task._id },
      company: this._AuthService.companyId()
    }).subscribe(async comments => {
      this.comments = comments;
      if (this.scrollToComments) {
        setTimeout(() => {
          this.scrollDialogToComments();
        }, 100);
      }
      this.scrollToComments = false;
    })
  }

  clientsTerm: string = '';
  get f() { return this.form?.controls; }
  async buildForm() {
    console.log('buildForm')
    console.log(this.task)
    const parseDate = (dateString: string) => {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(Date.UTC(year, month - 1, day));
    };

    let workers = (this.task.workers || []).map(el => el._id);
    let client = _.get(this.task, 'client._id', '');
    const category: any = _.get(this.task, 'category');
    const categoryId = _.isArray(category) && category.length > 0 ? category[0]?._id : category?._id ?? '';
    const scheduledAt = this.task.scheduledAt ? new Date(this.task.scheduledAt).getTime() : '';
    const scheduledStartRaw = this.task.scheduledStart ? this._UtilsService.date.toLocale(this.task.scheduledStart as any) : '';
    const scheduledEndRaw = this.task.scheduledEnd ? this._UtilsService.date.toLocale(this.task.scheduledEnd as any) : '';

    //separar fecha y hora
    let scheduledStart;
    let startTime;
    let scheduledEnd;
    let endTime;

    if (scheduledStartRaw) {
      const [date, time] = scheduledStartRaw.split('T');
      scheduledStart = date;
      startTime = new Date(this.task.scheduledStart || '')
    } else {
      scheduledStart = new Date().toISOString().split('T')[0];
      startTime = new Date()
    }

    if (scheduledEndRaw) {
      const [date, time] = scheduledEndRaw.split('T');
      scheduledEnd = date;
      endTime = new Date(this.task.scheduledEnd || '')
    } else {
      scheduledEnd = new Date().toISOString().split('T')[0];
      endTime = new Date()
      endTime.setHours(endTime.getHours() + 1)
    }
    //separar fecha y hora

    if (this.taskRequest?.description) {
      this.task.description = this.taskRequest?.description
    }

    if (this.taskRequest?.title) {
      this.task.title = this.taskRequest?.title
    }

    if (this.taskRequest?.attachments) {
      this.task.attachments = this.taskRequest?.attachments
    }

    let untilDateFormatted = '';
    if (this.untilDate && this.untilDate.includes("Luego de")) {
      this.currentUntilDate = '';
      untilDateFormatted = '';
    } else if (this.untilDate) {
      this.showUpdateUntilDate = true;
      this.currentUntilDate = this.untilDate ? parseDate(this.untilDate).toISOString().split('T')[0] : '';
      untilDateFormatted = this.untilDate ? parseDate(this.untilDate).toISOString().split('T')[0] : '';
    }

    this.form = this.fb.group({
      title: [this.task.title],
      client: [this.task.client, Validators.compose([Validators.required, clientValidator])],
      description: [this.task.description],
      location: [this.task.location, [Validators.required]],
      latitude: [_.get(this.task, 'coordinates[0]'), [Validators.required]],
      longitude: [_.get(this.task, 'coordinates[1]'), [Validators.required]],
      category: new FormControl({
        value: categoryId,
        disabled: this.readOnly || this.task?.status === 'INVOICED'
      }, [Validators.required]),
      status: [this.task.status, [Validators.required]],
      workers: new FormControl({
        value: workers,
        disabled: this.readOnly || this.task?.status === 'INVOICED'
      }),
      newProduct: [null, [productValidator]],
      // otherCharges: [this.task.otherCharges || 0],
      // discount: [this.task.discount || 0, [Validators.min(0)]],
      subtotal: [this.task.subtotal || 0],
      cost: [this.task.cost || 0],
      tax: [this.task.tax || 0],
      taxPercentage: [this.task.taxPercentage || 0],
      total: [this.task.total || 0],

      expenses: [this.task.expenses || null],
      totalExpenses: [this.task.totalExpenses || 0],

      scheduledAt: [scheduledAt],
      scheduledStart: [scheduledStart, [Validators.required]],
      scheduledEnd: [scheduledEnd, [Validators.required]],
      startTime: [startTime, [Validators.required]],
      endTime: [endTime, [Validators.required]],

      recurringFrequency: new FormControl({
        value: -1,
        disabled: this.readOnly || this.task?.status === 'INVOICED'
      }),
      recurringInterval: [1],
      recurringWDays: this.fb.array(
        [false, false, false, false, false, false, false].map(val => this.fb.control(val))
      ),
      recurringMDay: [],
      recurringEnd: new FormControl({
        value: 'ENDDATE',
        disabled: this.readOnly || this.task?.status === 'INVOICED'
      }),
      recurringUntil: [''],
      recurringCount: [1],
      updateUntilRecurrence: [untilDateFormatted, [updateUntilRecurrenceValidator.bind(this)]],

      isDeleted: [this.task.isDeleted],
      showStart: [this.showStart],
      showEnd: [this.showEnd],

      quote: [this.task.quote?._id ?? this.task.quote ?? undefined],
      serviceAgreement: [this.task.serviceAgreement?._id ?? this.task.serviceAgreement ?? undefined]
    }, {
      validators: [
        datesValidator(),
        locationValidator(),
        recurringValidator(),
      ]
    });

    this.$clients = this.f['client'].valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          this.clientsTerm = val;
          // if ((val || '').length < 1) return of([]);
          return this.filterClients(val || '')
        })
      );

    this.$products = this.f['newProduct'].valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          // if ((val || '').length < 1) return of([]);
          return this.filterProducts(val || '')
        })
      );

    this.subscriptions.add(this.form.valueChanges.subscribe(async event => await this.onFormValueChange(event)));

    if (this.task._id) this.getComments();
    if (this.action == 'Programar') {
      this.newClientSelected(this.task.client);
    }
  }

  async onFormValueChange(event: any) {
    //console.log(this.constructedForm)
    if (this.constructedForm) {
      this.formValueChanged = true;
    }
  }


  filterClients(val: string): Observable<any[]> {
    //para evitar errores en stream de mongo - gabi p
    if (typeof val === 'string') {
      return this._ClientsService.getClients({
        sort: 'firstname lastname',
        skip: 0,
        limit: 5000,
        filters: { client: val, isDeleted: false },
        company: this._AuthService.companyId()
      });
    } else {
      return new Observable<any[]>;
    }
  }

  newClientSelected(client: any) {
    const addresses = _.get(client, 'addresses', []);

    if (addresses.length >= 2) {
      this.openTaslClientAddressesSel(addresses)
    } else if (addresses.length == 1) {
      this.f['location'].setValue(_.get(addresses[0], 'address', ''));
      this.f['latitude'].setValue(_.get(addresses[0], 'coordinates[0]'));
      this.f['longitude'].setValue(_.get(addresses[0], 'coordinates[1]'));
    }
  }

  openTaslClientAddressesSel(addresses: ILocation[]) {
    let config = new MatDialogConfig();
    config.width = '500px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskClientAddressSelComponent, config);
    self.dialogRef.componentInstance.addresses = addresses;

    self.dialogRef.afterClosed().subscribe((address: any) => {
      self.dialogRef = null;
      this.f['location'].setValue(_.get(address, 'address', ''));
      this.f['latitude'].setValue(_.get(address, 'coordinates[0]'));
      this.f['longitude'].setValue(_.get(address, 'coordinates[1]'));
    });
  }

  async openDuplicateTaskModal(task: ITask, readOnly: boolean = false) {
    task = await lastValueFrom(this._TaskHttpService.getTask(task));

    const modalOptions: IConfirmationDialogOptions = {
      title: "Duplicar Trabajo",
      message: "Está seguro que desea crear un nuevo trabajo copiando el contenido seleccionado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let data = _.cloneDeep(task);
          data.status = 'SCHEDULED';

          delete data._id;
          delete data.createdAt;
          delete data.createdBy;
          delete data.scheduledStart;
          delete data.scheduledEnd;
          // console.log(data)

          let config = new MatDialogConfig();
          // config.disableClose = true;
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(TaskModalComponent, config);
          self.dialogRef.componentInstance.task = data;
          // self.dialogRef.componentInstance.readOnly = readOnly;
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.scheduling = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            self.dialogRef = null;
            this.dialog.close(this.task);
          });
        }
      });
  }

  filterProducts(item: string | IProduct): Observable<any[]> {
    let filter: any = {
      sort: 'name',
      skip: 0,
      limit: 5000,
      company: this._AuthService.companyId()
    };
    if (item) filter.filters = { name: item };
    filter.filters = { isDeleted: false };
    return this._ProductsService.getProducts(filter);
  }

  displayClientsFn(client: IClient): string {
    if (client) {
      const firstName = client.firstname?.trim();
      const lastName = client.lastname ? " " + client.lastname.trim() : '';
      return firstName + lastName;
    } else {
      return '';
    }
  }

  recurringTaskReset() {
    try { this.f['recurringFrequency'].setValue(-1); } catch (e) { }
    this.agreementInvoicing = false;
  }

  scheduledStartChange() {
    if (this.f['scheduledStart'].value && !this.task.scheduledEnd) {
      const startTime = new Date(this.f['scheduledStart'].value);
      const endTime = new Date(startTime);
      endTime.setHours(startTime.getHours() + 1);

      this.f['scheduledEnd'].setValue(this.f['scheduledStart'].value);
      // this.f.startTime.setValue(startTime);
      // this.f.endTime.setValue(endTime);
      if (!this.f['endTime'].value) {
        this.f['endTime'].setValue(endTime);
      }
    }

    const freq: Frequency | -1 = this.f['recurringFrequency'].value;
    if (freq == Frequency.WEEKLY) {
      for (let i = 0; i < 7; i++) this.f['recurringWDays'].value[i] = false;
      this.toggleRecWDay(new Date(this.f['scheduledStart'].value).getDay());
    }

    if (freq == Frequency.MONTHLY) {
      this.f['recurringMDay'].setValue(new Date(this.f['scheduledStart'].value).getDate());
    }
  }

  previousRecurringFrequency!: Frequency;
  recurringFrequencyChange() {
    const freq: Frequency = this.f['recurringFrequency'].value;

    if (this.previousRecurringFrequency != freq) {
      this.f['recurringInterval'].setValue(1);
      this.f['recurringEnd'].setValue('ENDDATE');
      this.f['recurringUntil'].setValue('2024-12-31');
      this.f['recurringCount'].setValue(1);
      for (let i = 0; i < 7; i++) this.f['recurringWDays'].value[i] = false;
    }

    if (freq == Frequency.WEEKLY) {
      this.toggleRecWDay(new Date(this.f['scheduledStart'].value).getDay());
    }

    if (freq == Frequency.MONTHLY) {
      this.f['recurringMDay'].setValue(new Date(this.f['scheduledStart'].value).getDate());
    }
  }

  setEditable(value: boolean = true) {
    if (value && (this.f['status'].value == 'INVOICED' || this.f['status'].value == 'CANCELLED')) {
      if (!this.notEditableAlert) {
        this.notEditableAlert = true;
        const taskStatus = this.f['status'].value == 'INVOICED' ? 'facturados' : 'cancelados';
        return this._AlertService.warn("No es posible editar trabajos " + taskStatus);
      }
      else return;
    }
    this.readOnly = !value;
  }

  openGetLocationModal() {
    let config = new MatDialogConfig();
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.locationDialogRef = this._dialog.open(LocationPickerModalComponent, config);
    let location: ILocation = {
      type: '',
      address: this.f['location'].value,
      coordinates: [this.f['latitude'].value, this.f['longitude'].value]
    };
    self.locationDialogRef.componentInstance.initialLocation = location;

    self.locationDialogRef.afterClosed().subscribe((result: any) => {
      self.locationDialogRef = null;
      if (result) {
        this.f['location'].setValue(result.addressSearched, result.address);
        this.f['latitude'].setValue(result.latitude);
        this.f['longitude'].setValue(result.longitude);
      }
    });
  }

  productsChanged = false;
  taskModalProductsChange(data: any) {
    this.productsChanged = true;
  }

  taskModalTotalsChange(data: any) {
    console.log(data)
    this.f['cost'].setValue(data.costsubtotal);
    this.f['subtotal'].setValue(data.subtotal);
    this.f['tax'].setValue(data.tax);
    this.f['taxPercentage'].setValue(data.taxPercentage);
    this.f['total'].setValue(data.total);
  }

  setRecurringTask(value: boolean = true) {
    if (!value) {
      recurringTask = false;
      this.recurringTask = false;
      this.recurringTaskReset();
    }
    else {
      if (this.scheduling) {
        if (moreThan24Hours)
          this._AlertService.warn("Recurrencia permitida para trabajos de menos de 24hs");
        else {
          recurringTask = true;
          this.recurringTask = true;
          // console.log(this.frequency.WEEKLY)
          // console.log(this.f)
          this.f['recurringFrequency'].setValue(this.frequency.WEEKLY);
          this.f['recurringUntil'].setValue('2024-12-31');
          this.toggleRecWDay(new Date(this.f['scheduledStart'].value).getDay());
        }
      }
      else {
        this._AlertService.warn("NO modificable");
      }
    }
  }

  private getWeekday(byWeekday: boolean[]): any {
    const result = byWeekday
      .map((v, i) => v && this.weekdayMap[i] || null)
      .filter(v => !!v);
    return result.length ? result : null;
  }

  toggleRecWDay(wday: number) {
    this.f['recurringWDays'].value[wday] = !this.f['recurringWDays'].value[wday];
  }

  async onSubmit(newStatus?: string) {

    if (moreThan24Hours && this.recurringTask) {
      this._AlertService.warn("Recurrencia permitida para trabajos de menos de 24hs");
      return;
    }

    if (this.productsChanged && this.task.deliverynote) {
      const modalOptions: IConfirmationDialogOptions = {
        title: "Editar trabajo incluido en albarán",
        message: "Si realiza este cambio, se retirará la firma del cliente del albarán.",
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };
      const confirmation = await this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).toPromise();
      if (!confirmation) return;
    }

    let user = this._AuthService.profile();

    const newTask: any = _.cloneDeep(this.form.value);
    console.log(newTask)

    this.saving = true;
    // validar data presubmit --------------------------------------------------------------------------
    let invalidData = false;
    const products: any = this.task.products;
    if (products.length >= 0) {
      products.map((item: any) => {
        if (item.quantity === 0) {
          this._AlertService.warn("Un concepto no puede tener cantidad 0");
          invalidData = true;
          return
        }
      });
    }
    if (newTask.category === null) {
      this.scrollDialogToTop();
      invalidData = true;
    }

    const expenses: any = this.task.expenses;
    expenses.map((item: any) => {
      if(item.vendor === '') item.vendor = null;
      if (!item.vendor?._id && item.vendor !== null) {
        this._AlertService.warn("Debes seleccionar un proveedor previamente cargado en tu base de datos o dejar el campo vacío");
        invalidData = true;
      }
    })

    if (invalidData) {
      this.saving = false;
      return
    };
    // validar data presubmit --------------------------------------------------------------------------

    this.submitted = true;
    if (this.form.invalid) {
      this.saving = false;
      return
    };
    // this.saving = true;
    delete newTask.newProduct;
    newTask.company = this._AuthService.companyId();

    newTask.expenses = expenses.map((item: any) => {
      console.log(item)
      let id = item._id
      //console.log(id)
      delete item._id
      return {
        expense: (item.expense?._id as string) || null,
        detail: item.detail || '',
        vendor: (item.vendor?._id as string) || null,
        description: item.description || this.emptyItemExpense.description,
        date: item.date || this.emptyItemExpense.date,
        quantity: item.quantity || this.emptyItemExpense.quantity,
        amount: item.amount || this.emptyItemExpense.amount,
        subtotal: item.subtotal || this.emptyItemExpense.subtotal,
        taxPercentage: item.taxPercentage || this.task.taxPercentage || this.emptyItemExpense.taxPercentage,
        tax: item.tax || this.emptyItemExpense.tax,
        total: item.total || this.emptyItemExpense.total,
      }
    });
    console.log(newTask.expenses)


    if (!newTask.expenses.length) {
      newTask.expenses = [this.emptyItemExpense];
    }

    newTask.products = products.map((item: any) => {
      // console.log(item)
      return {
        product: item.product?._id,
        name: item.detail || item.name,
        detail: item.detail || item.name || item.product?.name || '',
        description: item.description || this.emptyItem.description,
        quantity: item.quantity || this.emptyItem.quantity,
        unit: item.unit || this.emptyItem.unit,
        cost: item.cost || this.emptyItem.cost,
        price: item.price || this.emptyItem.price,
        subtotal: item.subtotal || this.emptyItem.subtotal,
        taxPercentage: item.taxPercentage || this.task.taxPercentage || this.emptyItem.taxPercentage,
        tax: item.tax || this.emptyItem.tax,
        total: item.total || this.emptyItem.total,
        addBy: item.addBy ?? "admin",
        addByUser: _.get(item, 'addByUser._id') ?? user.id
      }
    });

    if (!newTask.products.length) {
      newTask.products = [this.emptyItem];
    }

    if (this.project) newTask.project = this.project;
    if ((this.task as any).project) newTask.project = (this.task as any).project;

    // manually 2 way binding
    if (!newTask.status) newTask.status = this.task.status;

    if (newTask.scheduledAt) newTask.scheduledAt = new Date(newTask.scheduledAt).toISOString();
    else delete newTask.scheduledAt;
    if (newTask.scheduledStart) newTask.scheduledStart = combineDateTimeToISO(newTask.scheduledStart, newTask.startTime);
    else delete newTask.scheduledStart;
    if (newTask.scheduledEnd) newTask.scheduledEnd = combineDateTimeToISO(newTask.scheduledEnd, newTask.endTime);
    else delete newTask.scheduledEnd;

    delete newTask.startTime
    delete newTask.endTime

    newTask.coordinates = [newTask.latitude, newTask.longitude];
    delete newTask.latitude;
    delete newTask.longitude;

    delete newTask.showStart;
    delete newTask.showEnd;

    // calcular reglas; --------------------------------------------------------------------------
    // data.recurrence = reglas;

    if (newTask.status == 'SCHEDULED' && (newTask.recurringFrequency >= 0)) {
      //let dateUntil = this._UtilsService.date.localeEndOfDay(startDate);
      //console.log("dateUntil " + this._UtilsService.date.ISOtoLocaleDate(dateUntil));
      const options: Partial<Options> = {
        freq: newTask.recurringFrequency || Frequency.DAILY,
        dtstart: toNativeDate(new Date(newTask.scheduledStart) || new Date()),
        byweekday: newTask.recurringFrequency === Frequency.WEEKLY ? this.getWeekday(newTask.recurringWDays) : null,
        bymonthday: newTask.recurringFrequency === Frequency.MONTHLY ? newTask.recurringMDay : null,
        //until: !data.recurringUntil ? new Date() : new Date(data.recurringUntil),
      };
      if (newTask.recurringInterval > 1) {
        options.interval = newTask.recurringInterval;
      }
      if (newTask.recurringCount > 1) {
        options.count = newTask.recurringCount;
        delete options.until;
      } else {
        console.log(newTask.recurringUntil)
        let dateUntil = this._UtilsService.date.localeEndOfDay(newTask.recurringUntil);
        console.log(dateUntil)
        options.until = new Date(dateUntil);
      }

      const rule = new RRule(options);

      let index = (rule.toString()).lastIndexOf(":");
      const rruleSchedule = (rule.toString()).substring(index + 1);
      if (rule.all().length > 1) {
        this.rruleSchedule = rruleSchedule;
      }

    }
    // fin calcular reglas ------------------------------------------------------------------------

    delete newTask.recurringFrequency;
    delete newTask.recurringInterval;
    delete newTask.recurringWDays;
    delete newTask.recurringMDay;
    delete newTask.recurringEnd;
    delete newTask.recurringUntil;
    delete newTask.recurringCount;

    this.submitted = false;
    this.saving = false;

    if (this.agreementInvoicing && !this.task._id) {
      const newAgreement = {
        company: this._AuthService.companyId(),
        client: newTask.client?._id ?? newTask.client,
        category: newTask.category?._id ?? newTask.category,
        date: new Date(),
        dueDate: new Date(),
        details: _.cloneDeep(newTask.products.map((el: any) => {
          delete el.addBy; delete el.addByUser;
          return el;
        })),
        subtotal: newTask.subtotal,
        // taxPercentage: newTask.taxPercentage,
        tax: newTask.tax,
        total: newTask.total
      } as IServiceAgreement

      newTask.products.map((el: any) => {
        el.cost = 0; el.price = 0; el.subtotal = 0; el.tax = 0; el.taxPercentage = 0; el.total = 0;
        return el;
      });
      newTask.subtotal = 0; newTask.tax = 0; newTask.taxPercentage = 0; newTask.total = 0;

      const agreement = await lastValueFrom(this._ServiceAgreementHttpService.createAgreement(newAgreement));
      newTask.serviceAgreement = agreement._id;
    }


    if (this.formValueChanged) {

      this.refreshPage = true

      if (this.productsChanged && this.task.deliverynote && this.task.deliverynote.signature) {
        newTask.removeSignature = true;
      }

      if (newTask.updateUntilRecurrence === "") { delete newTask.updateUntilRecurrence; }

      if (newTask.updateUntilRecurrence === this.currentUntilDate) {
        delete newTask.updateUntilRecurrence;
      }

      if (this.task.attachments) {
        newTask.attachments = this.task.attachments.map((e: any) => e._id);
      }

      if (this.appoinment != null) {
        if (this.haveRecurrence != null) {
          newStatus !== 'COMPLETED' && newStatus !== 'INVOICED' ? this.saveMany(newTask) : this.save(newTask);
        } else {
          newStatus !== 'COMPLETED' && newStatus !== 'INVOICED' ? this.save(newTask, newStatus) : this.save(newTask);
        }
      } else {
        this.save(newTask, newStatus)
      }
    } else {
      this.setEditable(false);
      this.submitted = false;
      this.saving = false;
      this.dialog.close(newTask);
      if (newStatus) this.getTask(newStatus);
    }
  }

  save(data: any, newStatus?: string) {
    data.client = data.client._id;
    if (this.rruleSchedule != undefined) {
      data.recurrenceRule = this.rruleSchedule;
    }
    if (this.task._id) {
      data._id = this.task._id;
      data.appointmentId = this.appoinment._id;
      this._TaskHttpService.updateTask(data).subscribe((task: any) => {
        if (this.scheduling && !newStatus) {
          this.scheduledTaskCreationAlert();
          return this.dialog.close(task);
        }
        this.setEditable(false);
        this.submitted = false;
        this.saving = false;
        this.task = task;
        return this.dialog.close(task);
        // this.getTask(newStatus);
      });
    } else {
      delete data.updateUntilRecurrence;
      this._TaskHttpService.createTask(data).subscribe((task: any) => {
        if (this.taskRequest) {
          this._TaskRequestsService.updateTaskRequest({
            _id: _.get(this.taskRequest, 'taskRequest._id', this.taskRequest._id),
            company: this._AuthService.companyId(),
            status: 'ACCEPTED'
          }).subscribe(ok => {
            console.log(ok)
          })
        }
        if (this.scheduling && !newStatus) {
          this.scheduledTaskCreationAlert();
          return this.dialog.close(task);
        }
        this.setEditable(false);
        this.submitted = false;
        this.saving = false;
        this.task = task;
        return this.dialog.close(task);
        // this.getTask(newStatus);
      });
    }
  }

  saveMany(data: any, newStatus?: string) {
    const modalOptions: ICustomDialogOptions = {
      title: " ¿Qué cita(s) desea actualizar?",
      message: "Atención: los cambios de fecha se aplicarán solo a este trabajo",
      showYesAll: this.appoinment['schedule'] != null ? true : false,
      colorYesAllButton: "#a89532",
      yesAllButtonLabel: 'Esta cita y las siguientes', yesButtonLabel: 'Solo esta cita', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openCustomModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        data._id = this.task._id;
        data.client = data.client._id;
        data.appointmentId = this.appoinment._id;
        if (confirmation === true) {
          this._TaskHttpService.updateTask(data).subscribe((task: any) => {
            if (this.scheduling && !newStatus) {
              this.scheduledTaskCreationAlert();
              return this.dialog.close(task);
            }
            this.setEditable(false);
            this.submitted = false;
            this.saving = false;
            this.task = task;
            return this.dialog.close(task);
            // this.getTask(newStatus);
          });
        } else {
          this.saving = false;
        }
        if (confirmation == 3) {
          data.updateMany = true;
          this._TaskHttpService.updateTask(data).subscribe((task: any) => {
            if (this.scheduling && !newStatus) {
              this.scheduledTaskCreationAlert();
              return this.dialog.close(task);
            }
            this.setEditable(false);
            this.submitted = false;
            this.saving = false;
            this.task = task;
            return this.dialog.close(task);
            // this.getTask(newStatus);
          });
        }
      });
  }

  scheduledTaskCreationAlert() {
    this._AlertService.success('Se ha programado el trabajo en su Agenda y el personal asignado ha sido notificado de sus detalles');
  }

  confirmExit() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Salir",
      message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
      yesButtonLabel: 'Sí, deseo salir',
      noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          self.dialogRef.close();
        }
      });
  }

  closeModal() {
    if (!this.readOnly && this.formValueChanged) {
      this.confirmExit()
    } else {
      if (this.refreshPage) {
        self.dialogRef.close(this.task);
      } else {
        self.dialogRef.close();
      }
    }
  }

  cancelSubmit() {
    return this.dialog.close();
    if (!this.task._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(false);
    this.getTask();
  }

  openNewCategoryModal() {
    this.openCategoryModal({});
  }

  openCategoryModal(category: ICategory, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.cateDialogRef = this._dialog.open(CategoriesModalComponent, config);
    self.cateDialogRef.componentInstance.category = category;
    self.cateDialogRef.componentInstance.readOnly = readOnly;

    self.cateDialogRef.afterClosed().subscribe((result: any) => {
      self.cateDialogRef = null;
      if (result) {
        console.log(result);
        this.getCategories();
        // this.categories.push(result);
        this.task.category = [result];
        this.f['category'].setValue(result._id);
      }
    });
  }

  openNewClientModal() {
    this.openClientModal(true);
  }

  openClientModal(newClient: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '1000px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.clientdialogRef = this._dialog.open(ClientsModalComponent, config);
    self.clientdialogRef.componentInstance.client = !newClient ? this.f['client'].value : {};
    self.clientdialogRef.componentInstance.readOnly = false;

    self.clientdialogRef.afterClosed().subscribe((result: any) => {
      self.clientdialogRef = null;
      if (result) {
        this.task.client = result;
        this.f['client'].setValue(result);
        const address = _.get(result, 'addresses[0]', {});
        this.f['location'].setValue(_.get(address, 'address', ''));
        this.f['latitude'].setValue(_.get(address, 'coordinates[0]', 0));
        this.f['longitude'].setValue(_.get(address, 'coordinates[1]', 0));
      }
    });
  }

  clearClient() {
    this.f['client'].setValue(null);
    this.form.get('location')?.setValue('');
  }

  openWhatsapp() {
    const clientType = _.get(this.task, 'client.clientType', 'PERSON');
    if (clientType == 'PERSON') {
      const phones = _.get(this.task, 'client.phones', []);
      phones.forEach((phone: any) => {
        window.open(watsappURL({ text: '', phone: phone.number }))
      });
    } else {
      const contacts = _.get(this.task, 'client.clientContacts', []);
      contacts.forEach((contacts: any) => {
        window.open(watsappURL({ text: '', phone: contacts.phone }))
      });
    }
  }

  openWorkersWhatsapp() {
    const workers = _.get(this.f['workers'], 'value', []);
    const _workers = workers.map((el: any) => this.workers.find(w => w._id == el))
    if (_workers.length >= 2) {
      this.openTaskWorkerWhappSel(_workers);
    } else if (_workers.length == 1) {
      const phones = _.get(_workers[0], 'phones', []);
      phones.forEach((phone: any) => window.open(watsappURL({ text: '', phone: phone.number })));
    }
  }

  openTaskWorkerWhappSel(workers: IWorker[]) {
    let config = new MatDialogConfig();
    config.width = '500px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskWorkerWhappSelComponent, config);
    self.dialogRef.componentInstance.workers = workers;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openNewCommentModal() {
    let config = new MatDialogConfig();
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.commentDialogRef = this._dialog.open(TaskCommentComponent, config);
    self.commentDialogRef.componentInstance.task = this.task;

    self.commentDialogRef.afterClosed().subscribe((result: any) => {
      self.commentDialogRef = null;
      if (result) this.getComments();
    });
  }

  openMovementsModal() {
    let config = new MatDialogConfig();
    config.width = '1700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.movementsDialogRef = this._dialog.open(TaskMovementsComponent, config);
    self.movementsDialogRef.componentInstance.task = this.task;

    self.movementsDialogRef.afterClosed().subscribe((result: any) => {
      self.movementsDialogRef = null;
    });
  }

  openFile(file: IFile) {
    if (!file._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.fileDialogRef = this._dialog.open(FileViewModalComponent, config);
    self.fileDialogRef.componentInstance.file = file;

    self.fileDialogRef.afterClosed().subscribe((result: any) => {
      self.fileDialogRef = null;
    });
  }


  openDeleteUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "Disculpas por las molestias",
      message: "Por el momento, no es posible eliminar trabajos.\nHemos identificado un problema con esta funcionalidad que resolveremos a la brevedad.\nPuedes desasignar a tu personal para que no vea más el trabajo en su app móvil.",
      closeButtonLabel: "Aceptar"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok');
      });
  }

  openDeleteTaskConfirm() {
    // return this.openDeleteUnderConstructionDialog();

    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Trabajo",
      message: "Esta seguro que desea eliminar este Trabajo?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.deleteTask(this.task).subscribe(() => {
            //this.setEditable(false);
            this.dialog.close(this.task);
            //this.getTask();
          })
        }
      });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  openShareModal() {
    if (this.task._id) {
      if ((this.task?.status == 'QUOTED' || this.task.status == 'INVOICED')) {
        this.openSharedModal();
      } else {
        this.openExternalRequestModal()
      }
    }
  }

  openExternalRequestModal() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.shareDialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.shareDialogRef.componentInstance.task = this.task;

    self.shareDialogRef.afterClosed().subscribe((result: any) => {
      self.shareDialogRef = null;
    });
  }

  openSharedModal() {
    let config = new MatDialogConfig();
    config.width = '800px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.shareDialogRef = this._dialog.open(TaskShareComponent, config);
    self.shareDialogRef.componentInstance.task = this.task;
    self.shareDialogRef.componentInstance.showWhatsapp = (this.f['client'].value?.phones?.length > 0);
    self.shareDialogRef.componentInstance.showEmail = (this.f['client'].value?.email?.length > 0);
    self.shareDialogRef.afterClosed().subscribe((result: any) => {
      self.shareDialogRef = null;
    });
  }


  /*----------------- Detail ------------------*/
  onListChange(event: any) {
    // console.log(event);
    // this.f.details.setValue(event.items);
    this.f['cost'].setValue(event.totals.costsubtotal);
    this.f['subtotal'].setValue(event.totals.subtotal);
    this.f['tax'].setValue(event.totals.tax);
    this.f['total'].setValue(event.totals.total);
  }

  /*----------------- Expenses ------------------*/
  onListChangeExpenses(event: any) {
    console.log(event);
    this.f['expenses'].setValue(event.items);
    this.f['totalExpenses'].setValue(event.totals.total);
    //console.log(this.f['expenses']);
  }

  setInvoicingAgreement(aggrement: boolean) {
    this.agreementInvoicing = aggrement;
  }
}



function clientValidator(control: AbstractControl): any {
  if (control.value && !_.get(control.value, '_id')) {
    return { notFound: true };
  }
}

function locationValidator() {
  return (group: UntypedFormGroup) => {
    let locationControl = group.controls['location'];
    let latutudeControl = group.controls['latitude'];
    let longitudeControl = group.controls['longitude'];
    if (!locationControl.value || !latutudeControl.value || !longitudeControl.value)
      locationControl.setErrors({ fromMap: true })
    else locationControl.setErrors(null);
  }
}

function productValidator(control: AbstractControl): any {
  if (control.value && !_.get(control.value, '_id')) {
    return { notFound: true };
  }
}

function scheduledStartValidator(control: AbstractControl): any {
  if (control.value && (new Date(control.value).getTime() < (new Date().getTime() - (365 * 24 * 60 * 60 * 1000)))) {
    return { tooEarly: true };
  }
}

function updateUntilRecurrenceValidator(control: AbstractControl): { [key: string]: any } | null {
  if (control.value) {
    const selectedDate = new Date(control.value);
    const currentUntilDate = new Date(self.currentUntilDate);
    console.log(currentUntilDate)

    if (selectedDate < currentUntilDate) {
      return { lowerDate: true };
    }
  }
  return null;
}

function recurringValidator() {
  return (group: UntypedFormGroup) => {
    let recurringFrequencyControl = group.controls['recurringFrequency'];
    let recurringEndControl = group.controls['recurringEnd'];
    let recurringUntilControl = group.controls['recurringUntil'];
    let recurringCountControl = group.controls['recurringCount'];

    recurringUntilControl.setErrors(null);
    if (recurringFrequencyControl.value >= 0 && !recurringUntilControl.value && recurringEndControl.value === "ENDDATE") {
      recurringUntilControl.setErrors({ required: true });
    }
    if (recurringFrequencyControl.value >= 0 && recurringUntilControl.value && recurringEndControl.value === "ENDDATE") {
      const selectedDateInMillis = new Date(recurringUntilControl.value).getTime();
      const oneYearFromNowInMillis = new Date().getTime() + (365 * 24 * 60 * 60 * 1000);
      if (selectedDateInMillis > oneYearFromNowInMillis) {
        recurringUntilControl.setErrors({ moreThanYear: true });
      }
    }
    if (recurringFrequencyControl.value >= 0 && recurringCountControl.value && recurringEndControl.value === "ENDAFTER") {
      if (recurringCountControl.value > 156)
        recurringCountControl.setErrors({ limitRepetition: true });
    }
  }
}

function datesValidator() {

  const _AlertService = new AlertService();

  return (group: UntypedFormGroup) => {
    let statusControl = group.controls['status'];
    let showStart = group.controls['showStart'];
    let showEnd = group.controls['showEnd'];
    let startDateControl = group.controls['scheduledStart'];
    let endDateControl = group.controls['scheduledEnd'];
    let startTimeControl = group.controls['startTime'];
    let endTimeControl = group.controls['endTime'];
    let errors = {};


    let startControl
    if (endDateControl.value && endTimeControl.value) {
      startControl = combineDateTimeToISO(startDateControl.value, startTimeControl.value);
    } else {
      startControl = "";
    }
    let endControl
    if (endDateControl.value && endTimeControl.value) {
      endControl = combineDateTimeToISO(endDateControl.value, endTimeControl.value);
    } else {
      endControl = "";
    }

    if (!startControl && endControl) { errors = { ...errors, bothRequired: true }; }
    if (startControl && !endControl) { errors = { ...errors, bothRequired: true }; }

    let totalHours = (new Date(endControl).getTime() - new Date(startControl).getTime()) / (1000 * 3600);
    // if (totalHours > 24) { errors = { ...errors, moreThan24Horus: true }; }
    if (totalHours > 24) moreThan24Hours = true;
    else moreThan24Hours = false;

    if (moreThan24Hours && recurringTask)
      _AlertService.warn("Recurrencia permitida para trabajos de menos de 24hs");

    if (showStart.value && showEnd.value) {
      if (startControl > endControl) { errors = { ...errors, lowerThanStart: true }; }
    }

    if (_.get(startDateControl, "errors.tooEarly")) {
      errors = { ...errors, tooEarly: true };
    }

    if (Object.keys(errors).length === 0) {
      statusControl.setErrors(null);
      startDateControl.setErrors(null);
      endDateControl.setErrors(null);
    } else {
      statusControl.setErrors(errors);
      startDateControl.setErrors(errors);
      endDateControl.setErrors(errors);
    }
  }
}


function getValue(key: any, str: string) {
  const regex = new RegExp(`${key}=([^;]+)`);
  const match = str.match(regex);
  return match ? match[1] : null;
}

function combineDateTimeToISO(date: string, time: string | number | Date) {
  const timeValue = new Date(time);
  const hours = timeValue.getHours();
  const minutes = timeValue.getMinutes();

  let newTaskDate = new Date(date + 'T12:00:00.000Z');
  newTaskDate.setHours(hours);
  newTaskDate.setMinutes(minutes);
  newTaskDate.setDate(newTaskDate.getDate());

  const isoString = newTaskDate.toISOString();
  return isoString
}